import { render, staticRenderFns } from "./ScenceTypeInfoModal.vue?vue&type=template&id=8b154642&scoped=true"
import script from "./ScenceTypeInfoModal.vue?vue&type=script&lang=js"
export * from "./ScenceTypeInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b154642",
  null
  
)

export default component.exports